import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { ConsultantCard } from './ConsultantCard';
import { ServiceModal } from './ServiceModal';
import { useConsultants } from '../../hooks/useConsultants';
import { LoadingSpinner } from '../common/Loading';
import { ErrorMessage } from '../common/Error';
import type { Consultant } from '../../types/consultant';

export const ConsultantsGallery: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedConsultant, setSelectedConsultant] = useState<Consultant | null>(null);
  const [selectedService, setSelectedService] = useState<'chat' | 'email' | 'study' | null>(null);
  const { consultants, loading, error } = useConsultants();

  const handleServiceSelection = (consultantId: string, serviceType: 'chat' | 'email' | 'study') => {
    const consultant = consultants.find(c => c.id === consultantId);
    if (consultant) {
      setSelectedConsultant(consultant);
      setSelectedService(serviceType);
    }
  };

  const filteredConsultants = consultants.filter(consultant =>
    consultant.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    consultant.specialty.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-4">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-purple-300 w-5 h-5" />
          <input
            type="text"
            placeholder="Buscar por nome ou especialidade..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 input-primary"
          />
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-12">
          <LoadingSpinner />
        </div>
      ) : filteredConsultants.length === 0 ? (
        <div className="text-center text-purple-200/70 py-8">
          Nenhum consultor encontrado
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredConsultants.map(consultant => (
            <ConsultantCard
              key={consultant.id}
              consultant={consultant}
              onSelectService={handleServiceSelection}
            />
          ))}
        </div>
      )}

      {selectedConsultant && selectedService && (
        <ServiceModal
          consultant={selectedConsultant}
          serviceType={selectedService}
          onClose={() => {
            setSelectedConsultant(null);
            setSelectedService(null);
          }}
        />
      )}
    </div>
  );
};